import { AuthLayout, AuthShell, LoginForm } from '@features/auth';

/** Login route — Type A "Brand Split" layout wrapping the login form. */
const LoginPage = () => (
  <AuthLayout>
    <AuthShell>
      <LoginForm />
    </AuthShell>
  </AuthLayout>
);

export default LoginPage;
